/* Created by Interactive 63 - https://interactive63.com */
/**
 * Application entry point: loads global styles and mounts the editor shell.
 */
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import { createApp } from './editor/app';
import { installErrorHandlers } from './editor/error-handling';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app mount point');
installErrorHandlers();
createApp(root);
